<template>
  <div class="Logform">
    <div v-if="row && row.date_type" class="log">
      <div class="logt">日志所属周期:</div>
      <div class="logc">
        {{ row.date ? formatDate(row) : "系统根据实际提交情况展示" }}
      </div>
    </div>
    <template v-for="item in setlogcontent">
      <div
        class="log"
        :key="item.__vModel__"
        v-if="
          (item.type == 'input' ||
            item.type == 'textarea' ||
            item.type == 'date') &&
          (item.__config__.defaultValue || show)
        "
      >
        <div class="logt">{{ item.__config__.label }}:</div>
        <div class="logc">{{ item.__config__.defaultValue }}</div>
      </div>
      <div
        class="log"
        :key="item.__vModel__"
        v-if="
          item.type == 'attach' && (item.__config__.defaultValue.length || show)
        "
      >
        <div class="logt">{{ item.__config__.label }}:</div>
        <div
          v-for="(i, index) in item.__config__.fileList ||
          item.__config__.defaultValue"
          :key="index"
        >
          <el-button type="text" @click="handlePreview(i)">{{
            i.name || i
          }}</el-button>
        </div>
      </div>
      <div
        class="log"
        :key="item.__vModel__"
        v-if="item.__config__.tag == 'EditTable'"
      >
        <div class="logt">{{ item.__config__.label }}:</div>
        <el-table :data="item.__config__.defaultValue" style="width: 100%">
          <el-table-column type="index" width="80" label="序号">
          </el-table-column>
          <el-table-column
            :prop="i.prop"
            :label="i.label"
            v-for="i in item.columns"
            :key="i.prop"
          >
          </el-table-column>
        </el-table>
      </div>
    </template>
    <VueOfficeView
      ref="fileView"
      :fileType="fileType"
      :fileUrl="fileUrl"
      :fileName="fileName"
    ></VueOfficeView>
  </div>
</template>

<script>
import VueOfficeView from "@/components/VueOfficeView.vue";
export default {
  name: "Logform",
  components: { VueOfficeView },
  props: {
    logcontent: {
      type: Array,
      default: () => [],
    },
    row: {
      type: Object,
      default: () => {},
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      token: localStorage.getItem("token") || "",
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      fileType: 0,
      fileUrl: "",
      fileName: "",
    };
  },
  computed: {
    setlogcontent() {
      return this.logcontent.map((item) => {
        if (
          item.__config__.tag == "EditTable" &&
          item.__config__.defaultValue
        ) {
          console.log(
            item.__config__.defaultValue,
            item.__config__.defaultValue == '"[]"'
          );
        }
        // console.log( item.__config__.defaultValue, typeof JSON.parse(item.__config__.defaultValue.replace(/\"/g, '')), 123 );
        return {
          ...item,
          __config__: {
            ...item.__config__,
            defaultValue:
              (item.__config__.tag == "EditTable" || item.type == "attach") &&
              item.__config__.defaultValue
                ? JSON.parse(
                    item.__config__.defaultValue == '"[]"'
                      ? "[]"
                      : item.__config__.defaultValue
                  )
                : item.__config__.defaultValue.indexOf('"') == -1
                ? item.__config__.defaultValue
                : JSON.parse(item.__config__.defaultValue),
          },
        };
      });
    },
  },
  methods: {
    formatDate(item) {
      const dateType = item.date_type;
      const date = item.date;
      if (!date) return "";
      if (dateType === 1) {
        const year = date.substring(0, 4);
        const month = date.substring(4, 6);
        const d = date.substring(6);
        return `${year}年${month}月${d}日`;
      } else if (dateType === 2) {
        const year = date.substring(0, 4);
        const month = date.substring(4, 6);
        const week = date.substring(6);
        return `${year}年${parseInt(month)}月第${parseInt(week)}周`;
      } else if (dateType === 3) {
        const year = date.substring(0, 4);
        const month = date.substring(4);
        return `${year}年${parseInt(month)}月`;
      }
      return date;
    },
    handlePreview(row) {
      let url = row.url || row;
      let _suffix = url.substr(url.lastIndexOf("."));
      if (
        _suffix == ".pdf" ||
        _suffix == ".ppt" ||
        _suffix == ".mp3" ||
        _suffix == ".mp4" ||
        _suffix == ".jpeg" ||
        _suffix == ".jpg" ||
        _suffix == ".png" ||
        _suffix == ".gif"
      ) {
        window.open(url, "_blank");
        return;
      } else if (_suffix == ".xlsx" || _suffix == ".xls") {
        this.fileType = 5;
      } else if (_suffix == ".docx" || _suffix == ".doc") {
        this.fileType = 2;
      } else {
        return;
      }
      // // return
      this.fileUrl = url;
      this.fileName = row.name || url;
      let dom = this.$refs.fileView;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
  },
};
</script>
<style scoped lang="scss">
.Logform {
  padding: 0 20px;
  border-bottom: 1px solid #e5e5e5;
}
.log {
  padding: 10px 0;
}
.logt {
  font-size: 16px;
  color: #333;
  font-weight: 600;
  margin: 10px 0 0;
}
.logc {
  font-size: 16px;
  color: #333;
  margin: 10px 0 0;
  white-space: pre-line;
  line-height: 1.5;
}
</style>